export default __webpack_public_path__ + "6583ca1479ff2372885bef717b9027fe.png";